import React from 'react'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'
import ResearchKodaBlock from '../../../ResearchKodaBlock/ResearchKodaBlock'
import s from '../CountryCard/styles/CountryCard.module.scss'

const SkeletonCountryCard = () => {
	return (
		<article className={`${s.card} ${s.skeleton}`}>
			<header className={s.head}>
				<div className={s.head__row}>
					<span className={s.icon}>
						<span className={s.skeletonBlock} style={{ width: 28, height: 28 }} />
					</span>
					<span className={s.title}>
						<span className={s.skeletonBlock} style={{ width: 90, height: 16 }} />
					</span>
					<span className={s.btn}>
						<span className={s.skeletonBlock} style={{ width: 52, height: 12 }} />
					</span>
				</div>
			</header>
			<div className={s.body}>
				<div className={s.metrics}>
					<div className={s.metric}>
						<span className={s.metric__label}>Average salary</span>
						<strong className={s.metric__value}>
							<span className={s.skeletonBlock} style={{ width: 70, height: 14 }}>
								<LoaderImg color="green" />
							</span>
						</strong>
					</div>
					<div className={s.metric}>
						<span className={s.metric__label}>Number of jobs</span>
						<strong className={s.metric__value}>
							<span className={s.skeletonBlock} style={{ width: 60, height: 14 }}>
								<LoaderImg color="orange" />
							</span>
						</strong>
					</div>
				</div>
				<p className={s.region}>
					<span className={s.skeletonBlock} style={{ width: '60%', height: 12 }}>
						<LoaderImg />
					</span>
				</p>
				<ResearchKodaBlock loading />
			</div>
		</article>
	)
}

export default SkeletonCountryCard
